import React from 'react'
import { IProps } from '@/typings/utils'
import { IBrandList, IBrandWallProps, IStates } from './types'
import { SwiperBrand } from './comp/swiper-brand'
import { LineBrand } from './comp/line-brand'
import { ListBrand } from './comp/list-brand'
import { IRenderStatus } from '../poizon-new-user-coupon-v3/typing'
import { FailRender } from '@/common/fail-render'
import { isDuApp } from '@/utils/appUtils/getDevice'
import Jockeys from '@/utils/jockey'
import appInstall from '@/utils/appUtils/appInstall'
import styles from './index.module.less'

export enum SpuIdType {
  SPUID = 'SPUID',
  商品货号 = '商品货号',
}

export enum IBrandWall {
  swiper = '',
  list = 'oneOne',
  line = 'oneThree',
}
// 一排的渲染的方式
export enum IOneOneRender {
  限制 = 'custom',
  默认 = 'default',
}

// 国内的代码内容太过于内封，过多方法没有，直接用会有问题
class PoizonBrandWall extends React.Component<IProps<IBrandWallProps>, IStates> {
  static config = {
    name: '',
  }

  constructor(props: IProps<IBrandWallProps>) {
    super(props)

    if (props.propsConfig) {
      this.state = {
        renderStatus: IRenderStatus.start,
        ...props.propsConfig,
      }
    } else {
      this.state = {
        renderStatus: IRenderStatus.fail,
      }
    }
  }
  /**
   * keyWord: 路由、path、app、路由、
   * （你觉得什么搜索到这个比较简单就在keyword上加）
   * 请在数据输入层面限制数据规则，不要到这里再处理
   * app内http地址直接打开，否则走路由，路由表参考
   * app外http地址直接打开，否则走app安装
   */
  redirectUrl(item: IBrandList) {
    const { redirect } = item
    const openWithBrowser = redirect.startsWith('https://') || redirect.startsWith('http://')
    // 需要自动检测，防止用户瞎几把填写
    if (isDuApp()) {
      if (openWithBrowser) {
        Jockeys.openNativePage('/web/browser', { url: redirect })
      } else {
        Jockeys.openNativePage(redirect)
      }
    } else {
      if (openWithBrowser) {
        window.location.href = redirect
      } else {
        appInstall()
      }
    }
  }
  /****
   * 想优化这里的代码的话，很简单，3个类型的数据在PC端直接处理，合并非必要状态
   */
  render() {
    if (this.state.renderStatus === IRenderStatus.fail) return <FailRender />
    const {
      formType,
      packetLandingList,
      oneLine,
      oneThreeList,
      oneOneLoadNumber,
      oneOneRowNumber,
      oneOneShowRule,
      title,
    } = this.state
    let brandListRender
    if (formType === IBrandWall.line) {
      const brandList: IBrandList[] = []

      oneThreeList.forEach((item) => {
        item.oneThreeTable.forEach((brand) => {
          brandList.push({
            brandName: brand.oneThreeBrandName.name,
            brandLogo: brand.oneThreeBrandName.logoUrl,
            interestDesc: brand.oneThreeDes,
            brandBackImg: brand.oneThreeImage,
            redirect: brand.redirectValue,
            subTitle: '',
          })
        })
      })
      brandListRender = <LineBrand brandList={brandList} goToDetail={this.redirectUrl} />
    } else if (formType === IBrandWall.list) {
      const brandList: IBrandList[] = []

      oneLine.forEach((brand) => {
        brandList.push({
          brandName: brand.brandName.name,
          brandLogo: brand.brandName.logoUrl,
          interestDesc: brand.description,
          brandBackImg: brand.image,
          redirect: brand.redirectValue,
          subTitle: '',
        })
      })

      brandListRender = (
        <ListBrand
          lang={this.props.editConfig.lang}
          brandList={brandList}
          everyClick={oneOneLoadNumber}
          offset={oneOneRowNumber}
          rule={oneOneShowRule}
          goToDetail={this.redirectUrl}
        />
      )
    } else {
      const brandList: IBrandList[] = packetLandingList.map((item) => {
        item.redirect = item.redirectValue
        return item
      })

      brandListRender = <SwiperBrand brandList={brandList} goToDetail={this.redirectUrl} />
    }

    return (
      <div className={styles['container']}>
        <div className={styles['title']}>{title}</div>
        {brandListRender}
      </div>
    )
  }
}

PoizonBrandWall.config = {
  name: 'poizon-brand-wall',
}

export default PoizonBrandWall
